import React from 'react';
import $, { data } from 'jquery';
import "./nasa.css";

const Nasa = () => {
    {
        {
            $(document).ready(
                function () {
                    const data = require('./Nasa.json')
                    for (const propName in data.properties.parameter.TS) {
                        if (propName.substring(4, 6) !== "13") {
                            $("#mytable").append("<tr>\n" +
                                "        <td>" + propName.substring(4, 6) + "-" + propName.substring(0, 4) + "</td>\n" +
                                "        <td>" + data.properties.parameter.TS[propName] + "</td>\n" +
                                "        <td>" + data.properties.parameter.T2M[propName] + "</td>\n" +
                                "        <td>" + data.properties.parameter.QV2M[propName] + "</td>\n" +
                                "        <td>" + data.properties.parameter.RH2M[propName] + "</td>\n" +
                                "        <td>" + data.properties.parameter.T2MDEW[propName] + "</td>\n" +
                                "        <td>" + data.properties.parameter.T2MWET[propName] + "</td>\n" +
                                "        <td>" + data.properties.parameter.T2M_MAX[propName] + "</td>\n" +
                                "        <td>" + data.properties.parameter.T2M_MIN[propName] + "</td>\n" +
                                "        <td>" + data.properties.parameter.T2M_RANGE[propName] + "</td>\n" +
                              
                                "    </tr>");
                        }
                    }
                }
            )
        }
    }


    return (
        <div>
            <div className="table-responsive-sm ">
              
                <table id="mytable" className="table text-light">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Earth Skin Temperature</th>
                            <th>Temperature at 2 Meters</th>
                            <th>Specific Humidity at 2 Meters</th>
                            <th>Relative Humidity at 2 Meters</th>
                            <th>Dew/Frost Point at 2 Meters</th>
                            <th>Wet Bulb Temperature at 2 Meters</th>
                            <th>Temperature at 2 Meters Maximum</th>
                            <th>Temperature at 2 Meters Minimum</th>
                            <th>Temperature at 2 Meters Range</th>
                            
                            
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
    );
};

export default Nasa;